import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_BY_DEALER = gql`
  query LenderRetailActivityByDealer($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      byDealer(input: $input) {
        success
        error
        entity {
          dealerId
          dealerName
          country
          creditApps
          approved
          funded
          fundedAmount
          syndications
          units
        }
      }
    }
  }
`;
